import script from "./SavedSurvey.vue?vue&type=script&lang=ts&setup=true"
export * from "./SavedSurvey.vue?vue&type=script&lang=ts&setup=true"

import "./SavedSurvey.vue?vue&type=style&index=0&id=3da1ca88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3da1ca88"]])

export default __exports__